import token from 'styled-token';

/** @mixin fontWeightTypeMixin */
/**
 * Get the font weight for the given font type.
 *
 * @example
 * import { fontWeightTypeMixin } from '@zillow/constellation';
 *
 * // Adds support for "fontType" component prop
 * const Component = styled.div`
 *     ${fontWeightTypeMixin}
 * `;
 *
 * // Sets the default fontWeight to "h1"
 * const ComponentWithDefault = styled.div`
 *     ${props => fontWeightTypeMixin({ fontType: 'h1', ...props })}
 * `;
 *
 * <Component fontType="h2">h2 font weight</Component>
 * <ComponentWithDefault>h1 font weight by default</ComponentWithDefault>
 * <ComponentWithDefault fontType="h3">h3 font weight</ComponentWithDefault>
 *
 * @method
 * @param {object} props
 * @param {string} [props.fontType] - The `fontType` key for the `fontWeights` object.
 * @param {object} props.theme - The styled-components theme object with a `fontWeights` object.
 * @return {Interpolation}
 */
export var fontWeightTypeMixin = function fontWeightTypeMixin(props) {
  var fontType = props.fontType;
  if (!fontType) {
    return '';
  }
  return token('fontWeights', function (fontWeights) {
    var fontWeight = fontWeights && fontWeights[fontType];
    if (fontWeight) {
      return "font-weight: " + fontWeight + ";";
    }
    return '';
  })(props);
};